import {useUiStore} from "@/store/uiStore";
import {Outlet} from "react-router";
import {Header} from "./Header";
import {Sidebar} from "./Sidebar";

export const DashboardLayout = () => {
  const sidebarOpen = useUiStore(s => s.sidebarOpen);

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar collapsed={!sidebarOpen} />

      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Header />

        <main
          className="flex-1 overflow-y-auto"
          style={{backgroundColor: "var(--color-bg)"}}
        >
          <div className="max-w-7xl mx-auto p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};
